import Phaser from 'phaser'

const AGENTS = ['atlas', 'muse', 'pixel', 'echo', 'lens']
const DIRECTIONS = ['south', 'south-east', 'east', 'north-east', 'north', 'north-west', 'west', 'south-west']

export default class OfficeScene extends Phaser.Scene {
  constructor() {
    super('OfficeScene')
  }

  preload() {
    // Office background
    this.load.image('office-bg', '/assets/office-bg.png')

    // Agent directional sprites from PixelLab
    for (const name of AGENTS) {
      for (const direction of DIRECTIONS) {
        this.load.image(`${name}-${direction}`, `/assets/pixellab/${name}/rotations/${direction}.png`)
      }
    }
  }

  create() {
    // Fixed internal resolution (1920×1080) — Scale.FIT handles display scaling
    const W = 1920
    const H = 1080

    // Background image scaled to cover the fixed canvas
    const bg = this.add.image(W / 2, H / 2, 'office-bg')
    const scaleX = W / bg.width
    const scaleY = H / bg.height
    bg.setScale(Math.max(scaleX, scaleY))
    bg.setDepth(-1)

    // ── Calibration mode: click anywhere to get fixed pixel coordinates ────────
    // Toggle with 'C' key. Shows crosshair + coords on click, logs to console.
    this._calibrating = false
    this._calibMarkers = []
    this._calibLabel = this.add.text(10, 10, '', {
      fontSize: '14px',
      fontFamily: 'monospace',
      color: '#00ff00',
      backgroundColor: '#000000cc',
      padding: { x: 6, y: 4 },
    }).setDepth(999).setVisible(false)

    this.input.keyboard.on('keydown-C', () => {
      this._calibrating = !this._calibrating
      this._calibLabel.setVisible(this._calibrating)
      if (this._calibrating) {
        this._calibLabel.setText('CALIBRATION MODE — click to place markers (C to exit)')
        console.log('[Calibrate] ON — click the background to get coordinates')
      } else {
        // Clear markers
        this._calibMarkers.forEach(m => m.destroy())
        this._calibMarkers = []
        console.log('[Calibrate] OFF')
      }
    })

    this.input.on('pointerdown', (pointer) => {
      if (!this._calibrating) return
      const x = Math.round(pointer.worldX)
      const y = Math.round(pointer.worldY)

      // Visual marker
      const cross = this.add.text(x, y, '+', {
        fontSize: '20px',
        fontFamily: 'monospace',
        color: '#ff0000',
      }).setOrigin(0.5, 0.5).setDepth(998)
      const label = this.add.text(x + 12, y - 8, `${x}, ${y}`, {
        fontSize: '12px',
        fontFamily: 'monospace',
        color: '#ffff00',
        backgroundColor: '#000000cc',
        padding: { x: 3, y: 2 },
      }).setDepth(998)
      this._calibMarkers.push(cross, label)

      this._calibLabel.setText(`Last click: { x: ${x}, y: ${y} }`)
      console.log(`[Calibrate] { x: ${x}, y: ${y} }`)
    })

    // Signal to main.js that the scene is ready — agents.js and realtime
    // wiring should happen inside this handler to guarantee assets are loaded
    this.game.events.emit('scene-ready', this)
  }

  update(time, delta) {
    // Propagate the update tick to external systems (agents.js hooks here)
    this.game.events.emit('scene-update', time, delta)
  }
}
